import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import { useTranslation } from "i18n";

const cleanPhoneForLink = (raw) => {
  if (!raw) return "";
  const first =
    String(raw)
      .split(/[\s\/,]+/)
      .find((token) => /\d/.test(token)) || "";
  return first.replace(/\D/g, "");
};

const splitHours = (raw) => {
  if (!raw) return [];
  return String(raw)
    .split(/\\n|\n/)
    .map((line) => line.trim())
    .filter(Boolean);
};

const Branch = ({ branch }) => {
  const { t } = useTranslation();
  const isHeadOffice = branch?.name === "Head Office";
  const country = branch?.country || "suriname";
  const whatsappDigits = cleanPhoneForLink(branch?.whatsapp);
  const hours = splitHours(branch?.openeingHours);
  const displayName = isHeadOffice
    ? t("contact.branches.headOffice")
    : t("contact.branches.branchOffice");

  return (
    <article className="contact-branch">
      <div className="contact-branch__top">
        <span className="contact-branch__country">
          {t(`contact.branches.countries.${country}`)}
        </span>
        {isHeadOffice && <span className="contact-branch__hq">HQ</span>}
      </div>
      <h3>{displayName}</h3>
      <p className={`contact-branch__address${branch?.comingSoon ? " is-soon" : ""}`}>
        {branch?.comingSoon
          ? t("contact.branches.comingSoon")
          : branch?.address}
      </p>
      <dl className="contact-branch__meta">
        <div>
          <dt>{t("contact.branches.fields.phone")}</dt>
          <dd>{branch?.tel}</dd>
        </div>
        {hours.length > 0 && (
          <div>
            <dt>{t("contact.branches.fields.hours")}</dt>
            <dd>
              {hours.map((line) => (
                <div key={line}>{line}</div>
              ))}
            </dd>
          </div>
        )}
      </dl>
      {whatsappDigits && (
        <a
          className="contact-branch__chat"
          href={`https://wa.me/${whatsappDigits}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsAppIcon className="contact-branch__chat-icon" />
          {t("contact.branches.chatButton")}
        </a>
      )}
    </article>
  );
};

export default Branch;
